import { createClient } from '@supabase/supabase-js';
import cookieStorage from './cookieStorage';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

// storage = cookies con domain=.vlscr.net cuando corremos en producción
// (visitas.vlscr.net), para que la sesión se comparta con el hub y los
// demás subdominios (rw, comisiones, …).
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: cookieStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  }
});
